<div class="section container-fluid">
    <div class="row justify-content-center py-4">
        <div class="col-10">
            <div class="row">
                <div class="col-xl-4">
                    <img src="../../../../../assets/Images/child_Image.jpeg"
                    alt="choose a midwife" class="img-fluid">
                </div>
                <div class="mt-5 mt-xl-0 col-xl-8">
                    <div class="row">
                        <div class="col-sm-6 mb-5 pl-sm-5">
                            <span class="choose-midwife-title"> How I choose a midwife?</span>
                        </div>
                        <div class="col-sm-6 mb-5 pl-sm-5">
                            <div class="d-flex flex-row">
                                <span class="step-no ml-2 mr-3">1</span>
                                <div class="d-flex flex-column ml-3 pt-1">
                                    <span class="step-title">Go to the Mums & Midwife homepage</span>
                                    <span class="step-sub-text">Create an account and sign up – Click on sign up tab.</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 mb-5 pl-sm-5">
                            <div class="d-flex flex-row">
                                <span class="step-no">2</span>
                                <div class="d-flex flex-column  ml-3 pt-1">
                                    <span class="step-title">Select the area you live in and click Search </span>
                                    <span class="step-sub-text">Click on the region you live in, narrow your search down by selecting your suburb.</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 mb-5 pl-sm-5">
                            <div class="d-flex flex-row">
                                <span class="step-no">3</span>
                                <div class="d-flex flex-column  ml-3 pt-1">
                                    <span class="step-title">To narrow your search you can use additional filters</span>
                                    <span class="step-sub-text">Choose your preference of Midwife i.e – Homebirth, Birthing centre or Hospital </span>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 pl-sm-5 mb-5">
                            <div class="d-flex flex-row">
                                <span class="step-no">4</span>
                                <div class="d-flex flex-column  ml-3 pt-1">
                                    <span class="step-title">Midwife’s calendar lets you know which midwives are available</span>
                                    <span class="step-sub-text">Choose your preference of Midwife i.e – Homebirth, Birthing centre or Hospital.</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 pl-sm-5 mb-5">
                            <div class="d-flex flex-row">
                                <span class="step-no">5</span>
                                <div class="d-flex flex-column  ml-3 pt-1">
                                    <span class="step-title">Click on each midwife’s profile how to send messages</span>
                                    <span class="step-sub-text">Get the ball rolling and reach out to your CHOOSEN midwife my clicking on message </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
